import { render, staticRenderFns } from "./CourseVariationTableActions.vue?vue&type=template&id=6f2d1a27"
import script from "./CourseVariationTableActions.vue?vue&type=script&lang=js"
export * from "./CourseVariationTableActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports